import { Generic } from './Scrollable';
export function isScrollable(node) {
    return node !== null && typeof node === 'object' && node instanceof Generic;
}
export default isScrollable;    //# sourceMappingURL=isScrollable.js.map
